class PayloadContext {
	constructor(strategy) {
		this.strategy = strategy;
	}

	setStrategy(strategy) {
		this.strategy = strategy;
		return this;
	}

	getStrategy() {
		return this.strategy;
	}

	getPayloadToCreate() {
		return this.strategy.payloadToCreate();
	}

	getPayloadToUpdate() {
		return this.strategy.payloadToUpdate();
	}

	getPayloadToFetch() {
		return this.strategy.payloadToFetch();
	}

	getFiltrableProperties() {
		return this.strategy.filtrableProperties();
	}
}

export default PayloadContext;
